import { DatePicker } from "antd"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useRef } from "react"
import styled from "styled-components"

//------------------------------------------------------------------------------

function AppSelect(props) {
    const {
        className,
        placeholder,
        value,
        format,
        onChange,
        validationMessage,
        ...restProps
    } = props

    // -------------------------------------

    let containerRef = useRef(null)

    // -------------------------------------

    const defaultFormat = "DD/MM/YYYY"
    const pickerFormat = format || defaultFormat

    // -------------------------------------

    function handleChange(value) {
        const stringValue =
            (value && moment(value).format("YYYY-MM-DD")) || null

        onChange(stringValue)
    }

    // -------------------------------------

    const validValueClass =
        value !== undefined && value !== null && value !== ""
            ? "valid-value"
            : ""

    return (
        <div ref={containerRef} className={`${className} date-input-container`}>
            <DatePicker
                dropdownClassName="date-picker-dropdown"
                showSearch
                value={(value && moment(value)) || null}
                onChange={handleChange}
                // onBlur={onBlur}
                getCalendarContainer={() => {
                    return containerRef && containerRef.current
                }}
                placeholder={null}
                format={pickerFormat}
                {...restProps}
            />

            <label id="inputLabel" className={`input-label ${validValueClass}`}>
                {placeholder}
            </label>

            {validationMessage && (
                <span className="validation-error-message">
                    {validationMessage}
                </span>
            )}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppSelect.propTypes = {
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    mode: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    format: PropTypes.string,
    onBlur: PropTypes.func,
    validationMessage: PropTypes.string,
}

AppSelect.defaultProps = {
    onChange: () => {},
    onBlur: () => {},
    validationMessage: null,
}

// ----------------------------------------------------------------------------

const StyledAppSelect = styled(AppSelect)`
    & {
        position: relative;
        max-width: 326px !important;

        .date-input-container {
            position: relative;

            display: flex;
            flex-direction: column;
            border-radius: 6px;
            min-height: 42px;
            height: 42px;
            max-height: 42px;
            font-size: 17px;
            max-width: 326px !important;
            width: 100%;
            background-color: transparent;
        }

        .input-label {
            z-index: 1;
            position: absolute;
            top: 8.5px;
            left: 15px;
            font-size: 17px;
            color: #d6d6d6;
            transition: 0.3s ease all;
            -moz-transition: 0.3s ease all;
            -webkit-transition: 0.3s ease all;
        }

        .ant-calendar-picker {
            max-width: 326px;
            width: 100%;

            input {
                flex: 1;
                z-index: 2;
                border: 1px solid
                    ${(props) =>
                        (props.validationMessage && "rgb(255,59,48)") ||
                        "#d6d6d6"};
                border-radius: 6px;
                padding: 8px 15px 0 15px;
                min-height: 42px;
                height: 42px;
                max-height: 42px;
                width: 100%;
                font-family: -apple-system, "SF Pro Text", "SF Pro Icons",
                    "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
                background-color: transparent !important;
                font-size: 17px;
                color: #494949;
                outline: none;

                :focus {
                    outline-style: none;
                    border-color: #0070c9;
                }
            }

            :focus {
                outline: none;
            }
        }

        .date-picker-dropdown {
            /*top: 43px !important;*/

            top: 0 !important;

            .ant-calendar-input-wrap {
                /*display: none;*/
            }
        }

        .valid-value.input-label {
            position: absolute;
            top: 2px;
            color: #0070c9;
            font-size: 10px;
        }

        .validation-error-message {
            position: absolute;
            top: 50%;
            left: 102%;
            width: 50%;
            transform: translateY(-50%);
            font-size: 10px;
            font-weight: 600;
            color: rgb(255, 59, 48);
        }

        /* MOBILE */
        @media (max-width: ${(props) => props.theme.screenSizes.mobile}px) {
            .validation-error-message {
                position: absolute;
                top: 101%;
                left: 10px;
                width: 100%;
                transform: unset;
                line-height: 1;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledAppSelect
